import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Aside from "../../components/Aside";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Api from "../../services/api";
import { useForm, Controller } from "react-hook-form";
import swal from "sweetalert";
import { Grid } from "@material-ui/core";
import ConteudoEditor from "../guias/ConteudoEditor";

export default function EditBar() {
  const { slug } = useParams();
  const [bar, setBar] = useState(false);
  const [tags, setTags] = useState([]);
  const [novaTag, setNovaTag] = useState("");
  const [loading, setLoading] = useState(false);
  const Loader = () => <div className="loading"></div>;
  const { register, handleSubmit, setValue, control } = useForm();

  useEffect(() => {
    loadBar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  function loadBar() {
    setLoading(true);
    Api.get(`/bares/${slug}`)
      .then((response) => {
        const data = response.data[0];
        setBar(data);
        setTags(Array.isArray(data.tags) ? data.tags : []);
        [
          "nome",
          "titulo_pt", "titulo_en", "titulo_es",
          "teaser_pt", "teaser_en", "teaser_es",
          "texto_pt", "texto_en", "texto_es",
          "hero_imagem",
          "botao_label_pt", "botao_label_en", "botao_label_es",
        ].forEach((k) => setValue(k, data[k] || ""));
        setLoading(false);
      })
      .catch((err) => {
        console.error("ops! ocorreu um erro" + err);
        setLoading(false);
      });
  }

  function addTag() {
    const t = novaTag.trim();
    if (t && !tags.includes(t)) setTags([...tags, t]);
    setNovaTag("");
  }

  function removeTag(t) {
    setTags(tags.filter((x) => x !== t));
  }

  const onSubmit = (data) => {
    setLoading(true);
    const payload = { ...data, id: bar.id, tags: JSON.stringify(tags) };
    Api.post("/bares/edit", payload, {
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((response) => {
        if (response.data.status === "success") {
          swal("Sucesso!", response.data.message, "success");
        } else {
          swal("Erro!", response.data.message, "error");
        }
        setLoading(false);
      })
      .catch((err) => {
        swal("Erro!", "ops! ocorreu um erro: " + err, "error");
        setLoading(false);
      });
  };

  function renderTopPage() {
    return (
      <div className="top">
        <div>
          <span className="text">Conteúdo — {bar.nome}</span>
          <ul className="breadcrumbs">
            <li>{bar.nome}</li>
            <li>Conteúdo</li>
          </ul>
        </div>
      </div>
    );
  }

  function langTab(sufixo) {
    return (
      <TabPanel key={sufixo}>
        <Grid container className="form">
          <Grid item lg={12} md={12} sm={12} className="field">
            <label>Título</label>
            <input type="text" {...register(`titulo_${sufixo}`)} />
          </Grid>
          <Grid item lg={12} md={12} sm={12} className="field">
            <label>Teaser (texto curto do home)</label>
            <textarea rows="3" {...register(`teaser_${sufixo}`)}></textarea>
          </Grid>
          <Grid item lg={12} md={12} sm={12} className="field">
            <label>Texto (página completa)</label>
            <Controller
              name={`texto_${sufixo}`}
              control={control}
              render={({ field }) => (
                <ConteudoEditor value={field.value} onChange={field.onChange} />
              )}
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} className="field">
            <label>Rótulo do botão</label>
            <input type="text" {...register(`botao_label_${sufixo}`)} />
          </Grid>
        </Grid>
      </TabPanel>
    );
  }

  function renderContent() {
    return (
      <form onSubmit={handleSubmit(onSubmit)} className="form-sobrenos">
        <Grid container className="form">
          <Grid item lg={12} md={12} sm={12} className="field">
            <label>Nome (título da página)</label>
            <input type="text" {...register("nome")} />
          </Grid>
          <Grid item lg={12} md={12} sm={12} className="field">
            <label>Hero (caminho da imagem de fundo)</label>
            <input type="text" {...register("hero_imagem")} />
          </Grid>
          <Grid item lg={12} md={12} sm={12} className="field">
            <label>Tags</label>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "8px",
                margin: "6px 0 10px",
              }}
            >
              {tags.map((t) => (
                <span
                  key={t}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "8px",
                    background: "#f0a02a",
                    color: "#fff",
                    padding: "5px 12px",
                    borderRadius: "16px",
                    fontSize: "13px",
                    lineHeight: "1",
                  }}
                >
                  {t}
                  <button
                    type="button"
                    onClick={() => removeTag(t)}
                    aria-label={`Remover ${t}`}
                    style={{
                      border: "none",
                      background: "rgba(255,255,255,0.35)",
                      color: "#fff",
                      borderRadius: "50%",
                      width: "18px",
                      height: "18px",
                      lineHeight: "1",
                      fontSize: "13px",
                      cursor: "pointer",
                      padding: 0,
                    }}
                  >
                    ×
                  </button>
                </span>
              ))}
              {tags.length === 0 && (
                <span style={{ color: "#999", fontSize: "13px" }}>
                  Nenhuma tag ainda.
                </span>
              )}
            </div>
            <div style={{ display: "flex", gap: "8px" }}>
              <input
                type="text"
                value={novaTag}
                onChange={(e) => setNovaTag(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    addTag();
                  }
                }}
                placeholder="Nova tag"
                style={{ flex: 1 }}
              />
              <button
                type="button"
                onClick={addTag}
                style={{
                  padding: "6px 16px",
                  background: "#7ac77a",
                  color: "#fff",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  whiteSpace: "nowrap",
                }}
              >
                Adicionar
              </button>
            </div>
          </Grid>
        </Grid>
        <Tabs>
          <TabList>
            <Tab>
              <img src={process.env.PUBLIC_URL + "/images/flag-pt.png"} alt="pt" />
            </Tab>
            <Tab>
              <img src={process.env.PUBLIC_URL + "/images/flag-us.png"} alt="en" />
            </Tab>
            <Tab>
              <img src={process.env.PUBLIC_URL + "/images/flag-es.png"} alt="es" />
            </Tab>
          </TabList>
          {langTab("pt")}
          {langTab("en")}
          {langTab("es")}
        </Tabs>
        <div className="actions">
          <button type="submit" className="save">
            Salvar
          </button>
        </div>
      </form>
    );
  }

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container-box">
        <Aside />
        <main>
          {bar && renderTopPage()}
          {bar && renderContent()}
        </main>
      </div>
    </>
  );
}
